@if (variation === 1) {

<div class="wrapper">
  <div class="row justify-content-between" style="flex: 1">
    <div class="col">
      <div class="row justify-content-start">
        @if (cols) { @for (item of cols; track $index) {
        <div class="col-md-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '300px',
              'border-radius': '16px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        } }
      </div>

      <div class="row mt-3 d-flex justify-content-between align-items-center">
        <div class="col-md-4 col-lg-4">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              'border-radius': '16px',
              height: '60px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div class="col">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              'border-radius': '16px',
              height: '60px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div class="col-md-3 col-lg-2">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              'border-radius': '16px',
              height: '60px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div class="col-auto">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '150px',
              'border-radius': '16px',
              height: '60px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>

      <div class="row">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '400px',
            'background-color': '#e0e0e0'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>

} @if (variation === 3) {

<div class="wrapper">
  <div class="row justify-content-between" style="flex: 1">
    <div class="col-lg-8 col-md-7 w-67" style="height: 100%">
      <div class="row justify-content-around" style="height: 30%">
        @for (item of [1,2,3]; track $index) {
        <div class="col-sm-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '100%',
              'border-radius': '16px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>
        }
      </div>

      <div
        class="row mt-3 justify-content-between align-items-center"
        style="height: 10%"
      >
        <div class="col-md-7 col-lg-7">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '40px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div class="col-md-3 col-lg-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '40px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>

        <div class="col-lg-2">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '40px',
              'background-color': '#e0e0e0'
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>

      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '100%',
          height: '40%',
          'background-color': '#e0e0e0'
        }"
      ></ngx-skeleton-loader>
    </div>

    <div class="divider"></div>

    <div
      class="col-md-12 col-lg-3 w-28"
      style="height: 100%; padding-right: 40px"
    >
      <div class="right-wrapper" style="height: 100%">
        @for (item of [1,2]; track $index) {
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '45%',
            'border-radius': '16px',
            'background-color': '#e0e0e0',
            'margin-bottom': '35px'
          }"
        ></ngx-skeleton-loader>
        }
      </div>
    </div>
  </div>
</div>

}
